import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect } from "react";
import Page from "../../../components/layouts/Page";
import '../../../css/views/public/Rutes.css';

import entorn from '../../../../src/assets/img/entorn.jpg';

import ScrollToTop from "react-scroll-to-top";
import Idioma from "../../../components/elements/Idioma";
import PinatellIcon from "../../../components/elements/PinatellIcon";
import RutaEdit from "./RutaEdit";
import useScrollPosition from "../../../components/elements/useScrollPosition";
import ButtonAdmin from "../ButtonAdmin";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";

function RutesEdit(props) {
	
    const [peu, setPeu] = useState([])
    const [bici, setBici] = useState([])
    const navigate = useNavigate();

	const Background = (props) => {
		const [title, setTitle] = useState("Rutes");
        const [open, setOpen] = useState(true);

	const [animation, setAnimation] = useState("");
	const scrollPosition = useScrollPosition();
	const [line, setLine] = useState('');
    const [titleAni, setTitleAni] = useState('');

    

    useEffect(() => {
		setTimeout(() => {
			setLine('Portada-expand');
		}, 500);
        setTimeout(() => {

            setTitleAni('title-expand');
		}, 500);
        
    }, []);

	useEffect(() => {
		let height = window.innerHeight;

		let elementsToShowLeft = document.querySelectorAll(".show-on-scroll-left");
        elementsToShowLeft.forEach((element, index) => {
            if (element.getBoundingClientRect().top <= window.innerHeight-(window.innerHeight/2)) {
                element.classList.add('showOnScrollLeft');
            }
        })
        let elementsToShowRight = document.querySelectorAll(".show-on-scroll-right");
        elementsToShowRight.forEach((element, index) => {
            if (element.getBoundingClientRect().top <= window.innerHeight-(window.innerHeight/2)) {
                element.classList.add('showOnScrollRight');
            }
        })
        
    }, [scrollPosition]);

    function onClickAfegirEntorn(ruta) {
        navigate(props.masia.id+'/'+ruta+'/nou');
	}

    function onClickSubtitle(id){
        var access = document.getElementById(id);
        access.scrollIntoView({behavior: 'smooth'}, true);
    }

    // const url = 'http://127.0.0.1:8000/storage/';
    const url = 'https://api.masiaelpinatell.com/public/storage/';

		return (
			<Box>
				<div className="Rutes-fixed">
					<Typography variant='h2' className={"Rutes-title-fixed " + animation} maxWidth={'100%'} textAlign='center' textTransform='capitalize' color='#1D1D1B' fontWeight='800'><PinatellIcon extraClass='Pinatell-black'/></Typography>
				</div>
				<div style={{marginBottom: '116px'}}>
					<Box className="Rutes-portada">
						<div className="Home-idiomes">
							<Idioma selected={props.idioma} f_setSelected={props.f_setIdioma} idiomes={props.idiomes}/>
						</div>
						<div className="Rutes-image">
							<img src={entorn} className='Rutes-img'/>
						</div>
						<div className="Rutes-background"></div>
						<Box className={'Rutes-content ' + titleAni}>
							<Typography variant='h1' className="Rutes-title" color='#fff' textTransform='unset'>{props.masia?.rutes_titol}</Typography>
							<div onClick={()=>{onClickSubtitle('peu')}}><Typography variant='h4' className='Rutes-subtitle' color='#fff !important' marginTop='30px' textTransform='unset' fontFamily={'Quicksand'}>{'- ' + props.masia?.rutes_peu}</Typography></div>
							<div onClick={()=>{onClickSubtitle('bici')}}><Typography variant='h4' className='Rutes-subtitle' color='#fff !important' marginTop={props.isMobile ? '10px' : '30px'} textTransform='unset' fontFamily={'Quicksand'}>{'- ' + props.masia?.rutes_bici}</Typography></div>
						</Box>
						<div className={"Portada-line " + line}></div>
					</Box>
					{/* {props.masia?.entorns.map((item, index) => {
						return (
							<Place isLeft={index % 2 == 0 ? true : false} data={item} />
						)
					})} */}
                    <div id='peu' className="Ruta-section show-on-scroll-right" style={{display: 'flex', alignItems: 'center'}}>
                        <Typography variant='h2' className="Entorn-title" textTransform='capitalize' color={'#1D1D1B'} fontWeight='800'>{props.masia?.rutes_peu}</Typography>
                        <div style={{padding: '0.5rem 0rem 0.5rem 0.5rem', display: 'flex', justifyContent:'center', alignItems:'center', borderRadius: '0.4rem'}}>
                            <ButtonAdmin text={'Afegir Ruta a peu'} icon={<AddIcon />} style={{marginLeft: '60px'}} action={()=>{onClickAfegirEntorn('Ruta a peu')}}/>
                        </div>
                    </div>
                    {props.masia?.rutes.map((item, index) => {
                        if (item.tipus == 'Ruta a peu') {
                            return (
                                <RutaEdit isLeft={index % 2 == 0 ? true : false} data={item} setOpenDeleteModal={props.setOpenDeleteModal} setInitialValue={props.setInitialValue} setName={props.setName} setEndPoint={props.setEndPoint} setOpenModal={props.setOpenModal} setType={props.setType} setLabel={props.setLabel} setId={props.setId} setFolder={props.setFolder}/>
                            )
                        }
                    })}

                    <div id='bici' className="Ruta-section show-on-scroll-right" style={{display: 'flex', alignItems: 'center'}}>
                        <Typography variant='h2' className="Entorn-title" textTransform='capitalize' color={'#1D1D1B'} fontWeight='800'>{props.masia?.rutes_bici}</Typography>
                        <div style={{padding: '0.5rem 0rem 0.5rem 0.5rem', display: 'flex', justifyContent:'center', alignItems:'center', borderRadius: '0.4rem'}}>
                            <ButtonAdmin text={'Afegir Ruta en bici'} icon={<AddIcon />} style={{marginLeft: '60px'}} action={()=>{onClickAfegirEntorn('Ruta en bicicleta')}}/>
                        </div>
                    </div>
                    {props.masia?.rutes.map((item, index) => {
                        if (item.tipus == 'Ruta en bicicleta') {
                            return (
                                <RutaEdit isLeft={index % 2 == 0 ? true : false} data={item} setOpenDeleteModal={props.setOpenDeleteModal} setInitialValue={props.setInitialValue} setName={props.setName} setEndPoint={props.setEndPoint} setOpenModal={props.setOpenModal} setType={props.setType} setLabel={props.setLabel} setId={props.setId} setFolder={props.setFolder} />
                            )
                        }
                    })}
				</div>
			</Box>
		)
	}

	
	return (
		<Page title="El Pinatell">
			<Background peu={peu} bici={bici} masia={props.masia} isMobile={props.isMobile} idioma={props.idioma} f_setIdioma={props.f_setIdioma} idiomes={props.idiomes} setOpenDeleteModal={props.setOpenDeleteModal} setInitialValue={props.setInitialValue} setName={props.setName} setEndPoint={props.setEndPoint} setOpenModal={props.setOpenModal} setType={props.setType} setLabel={props.setLabel} setId={props.setId} setFolder={props.setFolder}/>

            <ScrollToTop smooth/>
		</Page>
	);
}

export default RutesEdit;